/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ExecuteFunctionTestRequestDto } from '../models/execute-function-test-request-dto';
import { FunctionTest } from '../models/function-test';
import { FunctionTestPartialExcludingIdProjectId } from '../models/function-test-partial-excluding-id-project-id';
import { NewFunctionTest } from '../models/new-function-test';

@Injectable({
  providedIn: 'root',
})
export class FunctionTestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation functionTestControllerExecuteTestForEvent
   */
  static readonly FunctionTestControllerExecuteTestForEventPath = '/function-test/workflow-event/{workflowEventId}/execute-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeTestForEvent()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeTestForEvent$Response(params: {
    workflowEventId: string;
    body?: ExecuteFunctionTestRequestDto
  }): Observable<StrictHttpResponse<Array<FunctionTest>>> {

    const rb = new RequestBuilder(this.rootUrl, FunctionTestControllerService.FunctionTestControllerExecuteTestForEventPath, 'post');
    if (params) {
      rb.path('workflowEventId', params.workflowEventId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FunctionTest>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeTestForEvent$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeTestForEvent(params: {
    workflowEventId: string;
    body?: ExecuteFunctionTestRequestDto
  }): Observable<Array<FunctionTest>> {

    return this.executeTestForEvent$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FunctionTest>>) => r.body as Array<FunctionTest>)
    );
  }

  /**
   * Path part for operation functionTestControllerExecuteTest
   */
  static readonly FunctionTestControllerExecuteTestPath = '/function-test/workflow-step-function/{workflowStepFunctionId}/execute-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeTest()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeTest$Response(params: {
    workflowStepFunctionId: string;
    body?: ExecuteFunctionTestRequestDto
  }): Observable<StrictHttpResponse<Array<FunctionTest>>> {

    const rb = new RequestBuilder(this.rootUrl, FunctionTestControllerService.FunctionTestControllerExecuteTestPath, 'post');
    if (params) {
      rb.path('workflowStepFunctionId', params.workflowStepFunctionId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FunctionTest>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeTest$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeTest(params: {
    workflowStepFunctionId: string;
    body?: ExecuteFunctionTestRequestDto
  }): Observable<Array<FunctionTest>> {

    return this.executeTest$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FunctionTest>>) => r.body as Array<FunctionTest>)
    );
  }

  /**
   * Path part for operation functionTestControllerFindById
   */
  static readonly FunctionTestControllerFindByIdPath = '/function-tests/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<FunctionTest>> {

    const rb = new RequestBuilder(this.rootUrl, FunctionTestControllerService.FunctionTestControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FunctionTest>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<FunctionTest> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<FunctionTest>) => r.body as FunctionTest)
    );
  }

  /**
   * Path part for operation functionTestControllerSoftDeleteById
   */
  static readonly FunctionTestControllerSoftDeleteByIdPath = '/function-tests/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `softDeleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  softDeleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, FunctionTestControllerService.FunctionTestControllerSoftDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `softDeleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  softDeleteById(params: {
    id: string;
  }): Observable<any> {

    return this.softDeleteById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation functionTestControllerUpdateById
   */
  static readonly FunctionTestControllerUpdateByIdPath = '/function-tests/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: FunctionTestPartialExcludingIdProjectId
  }): Observable<StrictHttpResponse<any>> {

    const rb = new RequestBuilder(this.rootUrl, FunctionTestControllerService.FunctionTestControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<any>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: FunctionTestPartialExcludingIdProjectId
  }): Observable<any> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<any>) => r.body as any)
    );
  }

  /**
   * Path part for operation functionTestControllerFind
   */
  static readonly FunctionTestControllerFindPath = '/function-tests';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<FunctionTest>>> {

    const rb = new RequestBuilder(this.rootUrl, FunctionTestControllerService.FunctionTestControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FunctionTest>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<FunctionTest>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FunctionTest>>) => r.body as Array<FunctionTest>)
    );
  }

  /**
   * Path part for operation functionTestControllerCreate
   */
  static readonly FunctionTestControllerCreatePath = '/function-tests';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewFunctionTest
  }): Observable<StrictHttpResponse<FunctionTest>> {

    const rb = new RequestBuilder(this.rootUrl, FunctionTestControllerService.FunctionTestControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FunctionTest>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewFunctionTest
  }): Observable<FunctionTest> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<FunctionTest>) => r.body as FunctionTest)
    );
  }

}
